import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { ProjectState } from 'store/Project/ProjectTypes'

export const setWaitingForNesting: CaseReducer<
  ProjectState,
  PayloadAction<boolean>
> = (state, action) => {
  state.projectOperations.waitingForNesting = action.payload
}
